import { Button, CircularProgress } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import React from 'react';
import LoginIcon from '@mui/icons-material/Login';

type CredentialsProps = {
  disabled: boolean;
};

const CredentialsForm: React.FC<CredentialsProps> = ({ disabled }) => {
  return (
    <>
      <Field
        size="small"
        component={TextField}
        required
        fullWidth
        margin="normal"
        id="email"
        label="Email"
        type="email"
        name="email"
        disabled={disabled}
      />
      <Field
        size="small"
        component={TextField}
        required
        fullWidth
        margin="normal"
        id="password"
        label="Password"
        type="password"
        name="password"
        disabled={disabled}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={disabled}
        startIcon={<LoginIcon />}
        sx={{ mt: 3 }}
      >
        {disabled ? <CircularProgress size={24} /> : 'Login'}
      </Button>
    </>
  );
};

export default CredentialsForm;
